/**
 * Computes precio_unitario from cost components and profit margin.
 * Formula: cost / (1 - porcentaje/100) — margin on selling price, not markup on cost.
 */
export function calcPrecioUnitario(
  precioMo: number,
  precioMateriales: number,
  porcentajeUtilidad: number,
): number {
  const costo = precioMo + precioMateriales;
  const divisor = 1 - porcentajeUtilidad / 100;
  return divisor > 0 ? costo / divisor : costo;
}

/**
 * Back-calculates porcentaje_utilidad from a manually entered precio_unitario.
 * Returns 0 if precio_unitario <= cost (avoids negative margins).
 */
export function calcPorcentajeFromPrecioUnitario(
  precioUnitario: number,
  precioMo: number,
  precioMateriales: number,
): number {
  const costo = precioMo + precioMateriales;
  if (precioUnitario <= 0 || precioUnitario <= costo) return 0;
  return (1 - costo / precioUnitario) * 100;
}
